module.exports = __webpack_public_path__ + "img/repost-otomatis.cd7ea41a.png";